import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    laneIds: [],
    laneTree: [],
    lanes: {},
    activeLane: null,
    order: [],
    error: null,
    loading: false,
    children: {}
};

const getLaneTreeStart = (state, action) => {
    return updateObject(state, { error: null, loading: true });
}

const getLaneTreeFail = (state, action) => {
    return updateObject(state, {
        error: action.error,
        loading: false
    });
}


const getLaneTreeSuccess = (state, action) => {
    const laneIds = [];
    const lanes = {};
    const laneTree = [];
    let elements = [];

    if (action.children && action.children.length) {
        elements = action.children.map(item => {
            if (item && item.project && item.project.data && item.project.data.id) {
                return ({ ...item.project, children: item.children || [], id: +item.project.data.id })
            }
        })
    }

    if (elements.length > 0) {
        elements.forEach((item, index) => {
            laneIds.push(item.id);
            laneTree.push(item);
            lanes[item.id] = [];
            let children = [];
            if (item.children && item.children.length) {
                item.children.forEach(el => {
                    if (el.project && el.project.data && el.project.data.id) {
                        children.push({ ...el.project, id: +el.project.data.id });
                        lanes[item.id].push(el.project.data.id);
                    }
                });
                item.children = children;
            }
        });
        console.log("LOGS: getLaneTreeSuccess elements", elements);
    }

    return updateObject(state, {
        laneIds: laneIds,
        laneTree: laneTree,
        loading: false,
        lanes: lanes,
        selectedWorkIds: []
    });
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.LANES_GET_PROJECT_TREE_START:
            return getLaneTreeStart(state, action);
        case actionTypes.LANES_GET_PROJECT_TREE_SUCCESS:
            return getLaneTreeSuccess(state, action);
        case actionTypes.LANES_GET_PROJECT_TREE_FAIL:
            return getLaneTreeFail(state, action);
        case actionTypes.LANES_UPDATE_OBJECTS_SUCCESS:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}

export default reducer;
